import { Action, createReducer, on } from '@ngrx/store';
import {
    addUserPopupPrefSuccess,
    getAppFeaturesSuccess,
    loadAppContext,
    loadAppContextFail,
    loadAppContextSuccess,
    loadOAuthPropertiesSuccess,
    searchTooltipsSuccess
} from './core.actions';
import { AppContextState, initialState } from './core.state';

const reducer = createReducer(
    initialState,
    on(
        loadAppContext,
        loadOAuthPropertiesSuccess,
        (state): AppContextState => ({
            ...state,
            isLoading: true
        })
    ),
    on(
        loadAppContextSuccess,
        (state, action): AppContextState => ({
            ...state,
            appContext: action.appContext,
            isLoading: false
        })
    ),
    on(
        loadAppContextFail,
        (state): AppContextState => ({
            ...state,
            isLoading: false
        })
    ),
    on(
        loadOAuthPropertiesSuccess,
        (state, action): AppContextState => ({
            ...state,
            oAuthProperties: action.oAuthProperties
        })
    ),
    on(
        searchTooltipsSuccess,
        (state, { tooltips }): AppContextState => ({
            ...state,
            tooltips: tooltips
        })
    ),
    on(
        getAppFeaturesSuccess,
        (state, action): AppContextState => ({
            ...state,
            appFeatures: action.appFeatures
        })
    ),
    on(
        addUserPopupPrefSuccess,
        (state, action): AppContextState => ({
            ...state,
            appContext: {
                ...state.appContext!,
                userPrefs: {
                    ...state.appContext?.userPrefs!,
                    userPopupPrefs: [...(state.appContext?.userPrefs?.userPopupPrefs ?? []), action.userPopupPrefs]
                }
            }
        })
    )
);

export function coreReducer(state: AppContextState, action: Action): AppContextState {
    return reducer(state, action);
}
